<ng-container *transloco="let t; read:'spoiler'">
  <div (click)="toggle()" [attr.aria-expanded]="!isCollapsed" class="btn spoiler" tabindex="0">
    <span *ngIf="isCollapsed; else show">{{t('click-to-show')}}</span>
    <ng-template #show>
      <div [innerHTML]="html | safeHtml"></div>
    </ng-template>
  </div>
</ng-container>
